import React from 'react';
import outdoorchapel from '../assets/img/outdoorchapel.jpg';
import sunset from '../assets/img/sunset.jpg';

const DoctrinalEthicalCovenant = props => {
    return (
        <div className="staticPage">
            <h1>Doctrinal and Ethical Covenant</h1>
            <h3>Our Doctrine</h3>
            <p>
                Youth Camps for Christ, Inc. accepts the brief Articles of Faith
                as follows:
            </p>
            <ul>
                <li>
                    That the Holy Bible was written by men divinely inspired of
                    God, and is a perfect treasure of Heavenly instruction.
                </li>
                <li>
                    That God eternally exists in three persons, the Father, the
                    Son, and the Holy Spirit.
                </li>
                <li>
                    That man, created in a state of holiness under God, fell
                    into the bondage of sin through the temptation of Satan.
                </li>
                <li>
                    That salvation of sinners is wholly of grace through the
                    atonement of our sins by the Lord Jesus Christ, who by the
                    Holy Spirit was born of the Virgin Mary and took upon him
                    our nature, yet without sin, truly God and truly man.
                </li>
                <li>
                    That the blessings of salvation are made free to all by the
                    Gospel, and upon repentance and faith, all true believers
                    endure to the end by the power of God.
                </li>
                <li>
                    That the Lord Jesus Christ, who was resurrected from the
                    tomb and ascended into Heaven, will visibly and personally
                    return to this earth in power and glory.
                </li>
            </ul>
            <img src={outdoorchapel} />
            <h3>Our Ethical Covenant</h3>
            <p>
                Youth Camps for Christ, Inc. accepts the brief Covenant of
                principle of Christian conducts as follows:
            </p>
            <ul>
                <li>
                    Having been led, as we believe, by the spirit of God, to
                    receive the Lord Jesus Christ as our Savior.
                </li>
                <li>
                    And on the profession of our faith, having been baptized in
                    the name of the Father, and the Son, and of the Holy Spirit.
                </li>
                <li>
                    We engage, therefore, by the aid of the Holy Spirit, to walk
                    together in Christian love; for the advancement of this
                    Corporation, in knowledge, holiness, and comfort.
                </li>
                <li>
                    To promote its prosperity and spirituality; to sustain its
                    purpose and doctrines.
                </li>
                <li>
                    To walk circumspectly in the world; to be just in our
                    dealings, faithful in our engagements, and exemplary in our
                    deportment.
                </li>
                <li>To avoid all tattling, backbiting, and excessive anger;</li>
                <li>
                    To abstain from the sale and use of intoxicating drinks as a
                    beverage, and illegal narcotic substances, and to be zealous
                    in our efforts to advance the kingdom of our Savior.
                </li>
                <li>
                    We further engage to watch over one another in brotherly
                    love.
                </li>
                <li>
                    To remember each other in prayer; and to cultivate Christian
                    sympathy in feeling and courtesy in speech.
                </li>
                <li>
                    To be slow to take offense, but always ready for
                    reconciliation, and mindful of the rules of our Savior to
                    secure it without delay.
                </li>
            </ul>
            <img src={sunset} />
            <h3>Our Cooperation</h3>
            <p>
                The cooperation of the Youth Camps for Christ, Inc. shall be
                with all evangelical Christian bodies who subscribe to the
                Articles of Faith and to the ethical covenant of the
                Corporation.
            </p>
        </div>
    );
};

export default DoctrinalEthicalCovenant;



// WEBPACK FOOTER //
// ./src/pages/doctrinal-ethical-covenant.js